const styles = () => ({
  previewPage: {
    background: '#717171',
    minHeight: '170vh',
  },
  previewPageMobile: {
    background: '#717171',
    minHeight: '101vh',
  },
  contentClass: {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    width: '100%',
    paddingTop: '0',
  },
});

export default styles;
